import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./StaffDetails.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { InputField, SearchInput, TextComponent } from "../../../../components";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/deleteIcon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";

const StaffDetails = () => {
    const [StaffDetailsModal, setStaffDetailsModal] = useState(false);
    const [quantity, setquantity] = useState(2);
    const [vendor, setvendor] = useState('');
    const [reason, setreason] = useState('');
    const [cost, setcost] = useState(2);
    const navigate = useNavigate();
    const location = useLocation();
    const formData = location.state || {};

    console.log('Received form data:', formData);

    const columns = [
        {
            title: "No",
            dataIndex: "No",
            key: "No",
        },
        {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
        },
        {
            title: "Day",
            key: "Day",
            dataIndex: "Day",
        },
        {
            title: "Check In  Time",
            key: "CheckInTime",
            dataIndex: "CheckInTime",
        },
        {
            title: "Check Out Time",
            key: "CheckOutTime",
            dataIndex: "CheckOutTime",
        },

    ];

    const data = [
        {
            No: "1",
            Date: "Jul 10, 2025 ",
            Day: "Monday",
            CheckInTime: " 8:34 am",
            CheckOutTime: " 4:22 pm",

        },
        {
            No: "2",
            Date: "Jul 11, 2025",
            Day: "Tuesday",
            CheckInTime: " 8:34 am",
            CheckOutTime: " 4:22 pm",

        },

    ];

    return (
        <div className={styles.mainCont}>
            <div className={styles.itemsHeadDiv}>
                <HeaderComponent
                    heading={"Stacy Doe"}
                    showBackIcon={true}

                />
                {/* <TextComponent backIcon className={styles.Heading} text={formData?.ingredientName} /> */}
                <div className={styles.itemsButtonDiv}>
                    <DeleteIcon width={20} height={20} />
                    <EditIcon width={20} height={20} />
                </div>
            </div>
            <div className={styles.itemsContDiv}>
                <div className={styles.itemsContDivRow}>
                    <div className={styles.itemsDiv}>

                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Staff ID:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="153534"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.unitOfMeasure}</div>
                    </div>


                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >

                            <TextComponent
                                text="Role :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Supervisor"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.shelfLife}</div>
                    </div>
                    <div className={styles.itemsDiv} style={{ display: "flex", flexDirection: "row", justifyContent: "right" }}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Status Badge:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Active"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.category}</div>
                    </div>
                </div>

                <div className={styles.itemsContDivRow}>
                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Branch Location:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Main City"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.allergen}</div>
                    </div>
                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Assigned Department:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Mixing"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.lowStockThreshold}</div>
                    </div>
                    <div className={styles.itemsDiv} style={{ display: "flex", flexDirection: "row", justifyContent: "right" }}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Designation :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="Oven Lead"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.shelfLife}</div>
                    </div>
                </div>
                <div className={styles.itemsContDivRow}>
                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Email :"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="stacy@mail.com"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.notes}</div>
                    </div>
                    <div className={styles.itemsDiv}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="Phone Number:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text="(401) 715-3344"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.notes}</div>
                    </div>
                    <div className={styles.itemsDiv} style={{ display: "flex", flexDirection: "row", justifyContent: "right" }}>
                        <div
                            className={styles.itemLabel}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <TextComponent
                                text="User ID:"
                                style={{
                                    fontFamily: 'Poppins-bold',
                                }}
                            />
                            <TextComponent
                                text=" 1247"
                                style={{
                                    fontFamily: 'Poppins-regular',
                                }}
                            />
                        </div>
                        <div className={styles.itemValue}>{formData?.notes}</div>
                    </div>

                </div>
            </div>
            <div className={styles.HeadingDiv}>
                <TextComponent className={styles.Heading} text={"Staff Attendence"}
                    style={{ marginTop: '14px', }}
                />

            </div>

            {/* Table Section */}
            <div className={styles.subCont}>
                <div className={styles.TableDiv}>
                    <Table
                        scroll={{ x: true }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        rowKey="No"
                    />
                </div>
            </div>


        </div>
    );
};

export default StaffDetails;
